var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("text-" + (_vm.params.color))},[_c('i',{class:_vm.params.icon}),_c('span',{staticClass:"m-0 ml-2 font-weight-bold"},[_vm._v(_vm._s(_vm.params.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }